(function () {
  if (window.__aqColorNavigatorLoaded) return;
  window.__aqColorNavigatorLoaded = true;

  const sizeOptionSelectors = {
    checked: [
      'select[name^="options[Menge]"]',
      'select[name^="options[Inhalt]"]',
      'select[name^="options[Size]"]',
      'select[name^="options[Größe]"]',
      'select[name^="options[Grösse]"]',
      'select[name^="options[Groesse]"]',
      'input[name^="options[Menge]"]:checked',
      'input[name^="options[Inhalt]"]:checked',
      'input[name^="options[Size]"]:checked',
      'input[name^="options[Größe]"]:checked',
      'input[name^="options[Grösse]"]:checked',
      'input[name^="options[Groesse]"]:checked'
    ],
    all: [
      'select[name^="options[Menge]"]',
      'select[name^="options[Inhalt]"]',
      'select[name^="options[Size]"]',
      'select[name^="options[Größe]"]',
      'select[name^="options[Grösse]"]',
      'select[name^="options[Groesse]"]',
      'input[name^="options[Menge]"]',
      'input[name^="options[Inhalt]"]',
      'input[name^="options[Size]"]',
      'input[name^="options[Größe]"]',
      'input[name^="options[Grösse]"]',
      'input[name^="options[Groesse]"]'
    ]
  };

  function normalizeValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getSelectedSize() {
    for (const selector of sizeOptionSelectors.checked) {
      const el = document.querySelector(selector);

      if (el && el.value) {
        return el.value.trim();
      }
    }

    return null;
  }

  function getSizeInputs() {
    return sizeOptionSelectors.all.flatMap(function (selector) {
      return Array.from(document.querySelectorAll(selector));
    });
  }

  function preselectSizeFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const size = params.get('size');

    if (!size) return;

    const normalizedSize = normalizeValue(size);

    getSizeInputs().forEach(function (el) {
      if (!el.value) return;

      const normalizedValue = normalizeValue(el.value);

      if (el.tagName === 'SELECT') {
        const option = Array.from(el.options).find(function (optionEl) {
          return normalizeValue(optionEl.value) === normalizedSize;
        });

        if (option) {
          el.value = option.value;
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (normalizedValue === normalizedSize) {
        el.checked = true;
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function getOptionCountText(option) {
    const count = parseInt(option.dataset.aqFamilyCount || '0', 10);

    if (!count) return '';

    return count === 1 ? '1 Farbe' : count + ' Farben';
  }

  function setFamilySelectListLabels(select) {
    if (!select) return;

    Array.from(select.options).forEach(function (option) {
      const label = option.dataset.aqFamilyLabel || option.textContent.trim();
      option.textContent = label;
    });
  }

  function setFamilySelectClosedLabel(select) {
    if (!select || !select.selectedOptions || !select.selectedOptions.length) return;

    setFamilySelectListLabels(select);

    const selectedOption = select.selectedOptions[0];
    const label = selectedOption.dataset.aqFamilyLabel || selectedOption.textContent.trim();
    const countText = getOptionCountText(selectedOption);

    selectedOption.textContent = countText ? label + ' · ' + countText : label;
  }

  function initFamilySelectDisplay(select) {
    if (!select) return;

    Array.from(select.options).forEach(function (option) {
      if (!option.dataset.aqFamilyLabel) {
        option.dataset.aqFamilyLabel = option.textContent.trim();
      }
    });

    setFamilySelectClosedLabel(select);

    ['pointerdown', 'mousedown', 'touchstart', 'focus'].forEach(function (eventName) {
      select.addEventListener(eventName, function () {
        setFamilySelectListLabels(select);
      });
    });

    ['blur', 'mouseup'].forEach(function (eventName) {
      select.addEventListener(eventName, function () {
        window.setTimeout(function () {
          setFamilySelectClosedLabel(select);
        }, 0);
      });
    });
  }

  function initColorNavigator(nav) {
    if (nav.dataset.aqInitialized === 'true') return;
    nav.dataset.aqInitialized = 'true';

    const familySelect = nav.querySelector('[data-aq-family-select]');
    const swatches = Array.from(nav.querySelectorAll('[data-aq-swatch]'));
    const count = nav.querySelector('[data-aq-color-count]');
    const params = new URLSearchParams(window.location.search);

    let activeFamily = params.get('family') || nav.dataset.currentFamily || 'all';

    if (familySelect) {
      const validValues = Array.from(familySelect.options).map(function (option) {
        return option.value;
      });

      if (!validValues.includes(activeFamily)) {
        activeFamily = validValues.includes('all') ? 'all' : validValues[0];
      }

      initFamilySelectDisplay(familySelect);
    }

    function getAvailableSizes(swatch) {
      const raw = swatch.dataset.availableSizes || '';

      return raw
        .split('||')
        .map(function (size) {
          return normalizeValue(size);
        })
        .filter(Boolean);
    }

    function updateCount(visibleSwatches) {
      if (!count) return;

      const visibleCount = visibleSwatches.length;
      count.textContent = visibleCount === 1 ? '1 Farbe' : visibleCount + ' Farben';
    }

    function syncFamilySelect() {
      if (!familySelect) return;

      familySelect.value = activeFamily;
      setFamilySelectClosedLabel(familySelect);
    }

    function updateAvailabilityState() {
      const selectedSize = getSelectedSize();
      const normalizedSelectedSize = normalizeValue(selectedSize);

      swatches.forEach(function (swatch) {
        if (!normalizedSelectedSize) {
          swatch.classList.remove('is-size-unavailable');
          return;
        }

        const availableSizes = getAvailableSizes(swatch);
        const isAvailableInSelectedSize = availableSizes.includes(normalizedSelectedSize);

        swatch.classList.toggle('is-size-unavailable', !isAvailableInSelectedSize);
      });
    }

    function persistFamilyInUrl() {
      try {
        const url = new URL(window.location.href);

        if (activeFamily && activeFamily !== 'all') {
          url.searchParams.set('family', activeFamily);
        } else {
          url.searchParams.delete('family');
        }

        history.replaceState({}, '', url.toString());
      } catch (error) {
        // no-op
      }
    }

    function applyFilter(family) {
      activeFamily = family || 'all';

      const visibleSwatches = swatches.filter(function (swatch) {
        return activeFamily === 'all' || swatch.dataset.family === activeFamily;
      });

      swatches.forEach(function (swatch) {
        const matches = activeFamily === 'all' || swatch.dataset.family === activeFamily;
        swatch.hidden = !matches;
      });

      syncFamilySelect();
      updateCount(visibleSwatches);
      updateAvailabilityState();
      persistFamilyInUrl();
    }

    if (familySelect) {
      familySelect.addEventListener('change', function () {
        applyFilter(familySelect.value);

        window.setTimeout(function () {
          setFamilySelectClosedLabel(familySelect);
        }, 0);
      });
    }

    getSizeInputs().forEach(function (input) {
      input.addEventListener('change', function () {
        updateAvailabilityState();
      });
    });

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        const selectedSize = getSelectedSize();

        try {
          const url = new URL(swatch.href, window.location.origin);

          if (selectedSize) {
            url.searchParams.set('size', selectedSize);
          }

          if (activeFamily && activeFamily !== 'all') {
            url.searchParams.set('family', activeFamily);
          } else {
            url.searchParams.delete('family');
          }

          swatch.href = url.toString();
        } catch (error) {
          // Fallback: normaler Link bleibt bestehen.
        }
      });
    });

    applyFilter(activeFamily);
  }

  function initAllColorNavigators() {
    preselectSizeFromUrl();

    document.querySelectorAll('[data-aq-color-nav]').forEach(function (nav) {
      initColorNavigator(nav);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllColorNavigators);
  } else {
    initAllColorNavigators();
  }

  document.addEventListener('shopify:section:load', initAllColorNavigators);
})();